import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api';

export default function Links() {
  const [links, setLinks] = useState([]);
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/links').then(r => { setLinks(r.data); setLoading(false); });
  }, []);

  async function create() {
    if (!url) return toast.error('Enter a URL');
    try {
      const r = await api.post('/links', { original_url: url });
      setLinks(ls => [r.data, ...ls]);
      setUrl('');
      toast.success('Short link created!');
    } catch (e) { toast.error('Failed to create link'); }
  }

  async function handleDelete(id) {
    await api.delete(`/links/${id}`);
    setLinks(ls => ls.filter(l => l._id !== id));
    toast.success('Deleted');
  }

  function copyLink(shortUrl) {
    navigator.clipboard.writeText(shortUrl);
    toast.success('Copied!');
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Link Tracker</h1>
      </div>

      <div className="card" style={{ marginBottom: 20 }}>
        <div className="card-title">Create Tracked Short Link</div>
        <div style={{ display: 'flex', gap: 10 }}>
          <input className="input" value={url} onChange={e => setUrl(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && create()}
            placeholder="https://your-destination-url.com" />
          <button className="btn btn-primary" onClick={create}>Shorten</button>
        </div>
        <p style={{ color: 'var(--text-muted)', fontSize: 12, marginTop: 8 }}>
          Use these links in your broadcasts to track click-through rates.
        </p>
      </div>

      <div className="card">
        <div className="card-title">Your Links</div>
        {loading ? <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>Loading…</div> :
          links.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">🔗</div>
              <div className="empty-state-text">No links yet — create one above</div>
            </div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr><th>Short URL</th><th>Original URL</th><th>Clicks</th><th>Created</th><th></th></tr>
                </thead>
                <tbody>
                  {links.map(l => (
                    <tr key={l._id}>
                      <td>
                        <span style={{ color: 'var(--primary-light)', fontWeight: 500 }}>{l.short_url}</span>
                        <button className="btn btn-ghost btn-sm" style={{ marginLeft: 8 }} onClick={() => copyLink(l.short_url)}>Copy</button>
                      </td>
                      <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: 'var(--text-muted)', fontSize: 13 }}>
                        <a href={l.original_url} target="_blank" rel="noopener noreferrer">{l.original_url}</a>
                      </td>
                      <td>
                        <span className="badge badge-purple" style={{ fontSize: 13 }}>
                          {l.click_count} {l.click_count === 1 ? 'click' : 'clicks'}
                        </span>
                      </td>
                      <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{new Date(l.createdAt).toLocaleDateString()}</td>
                      <td><button className="btn btn-danger btn-sm" onClick={() => handleDelete(l._id)}>Delete</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </div>
    </div>
  );
}
